<div class="modal-header">
  <h4 class="modal-title">Take Customer Photo</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div class="d-inline-block w-100 text-center" *ngIf="!errorMessage">
    <webcam *ngIf="!errorMessage"
            [trigger]="takeImageObservable"
            (imageCapture)="handleImageCapture($event)"
            (initError)="handleWebcamInitError($event)"></webcam>
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary"
          (click)="handleSave()">
    Take Photo
  </button>
</div>
